<template>
  <v-card v-if="$keycloak.hasResourceRole('heg-lang', 'aloha-admin-app')">
    <v-card-title>
      <span class="subheading">Liste des étudiants HEG pour les langues</span>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Rechercher..."
        color="teal"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="students"
      :search="search"
      :loading="loading"
      :pagination.sync="pagination"
      rows-per-page-text="Résultats par page"
      :rows-per-page-items="[5, 10, 25]"
      :no-data-text="loading ? 'Chargement des données...' : 'Pas de données'"
      no-results-text="Aucun résultat pour les termes recherchés"
    >
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.lastName }}</td>
        <td class="text-xs-left">{{ props.item.firstName }}</td>
        <td class="text-xs-left">{{ props.item.emailPrive }}</td>
        <td class="text-xs-left">{{ props.item.languages }}</td>
        <td class="text-xs-left">
          {{ props.item.accountNotifiedAt | formatDate }}
        </td>
        <td class="text-xs-left">{{ props.item.notificationsLength }}</td>
      </template>
      <template v-slot:actions-append>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" @click="exportToCsv" class="ma-2">
              <v-icon class="material-icons-outlined">cloud_download</v-icon>
            </v-btn>
          </template>
          <span>Export XLSX</span>
        </v-tooltip>
      </template>
      <template v-slot:pageText="props"
        >Lignes {{ props.pageStart }} - {{ props.pageStop }} de
        {{ props.itemsLength }}</template
      >
    </v-data-table>
  </v-card>
</template>

<script>
import { filters } from '../mixins';

export default {
  mixins: [filters],
  props: ['students', 'loading', 'exportToCsv'],
  data: () => ({
    search: '',
    clientUri: process.env.VUE_APP_CLIENT_URI,
    pagination: {
      rowsPerPage: 10,
      sortBy: 'lastName',
    },
    headers: [
      { text: 'Nom', value: 'lastName' },
      { text: 'Prénom', value: 'firstName' },
      { text: 'Email privé', value: 'emailPrive' },
      { text: 'Langues', value: 'languages' },
      { text: 'Notification', value: 'accountNotifiedAt' },
      { text: 'Admission précédente', value: 'notificationsLength' },
    ],
  }),
};
</script>